import { FunctionComponent } from 'react'
import { Concept as ConceptProps } from './Concept.types'
import './Concept.scss'
import { Button } from '../primitives/Button/Button'

export const Concept: FunctionComponent<ConceptProps> = ({ attributes }) => {
  return (
    <div className="core-ux-concept-filter">
      <Button {...attributes.item} className="core-ux-concept-filter__button" />
    </div>
  )
}
